import { toUpper } from 'lodash'
import Heading from '@react/react-spectrum/Heading'

import * as COMPONENTS from '../fragments/profile-modules'
import TopRibbon from '../fragments/TopRibbon/TopRibbon'
import { useRootContext } from '../root/RootContext'

export const WrapperComponent = (component, passedProps) => {
  const { project } = useRootContext()
  try {
    let type = component?.meta?.component?.replace(/^(.)/, toUpper)
    const Component = COMPONENTS[type]
    const showRibbon = Component.requiresLaunch && !project?.integrations?.aep?.imsOrg

    if (!Component) return null
    return (
      <div>
        <Heading
          variant='subtitle2'
          style={{
            padding: '1rem',
            backgroundColor: project.branding.backgroundColor,
            color: project.branding.primaryTextColor,
            fontFamily: project.branding.bodyFont,
          }}
        >
          {component?.content.title}
        </Heading>
        {showRibbon && <TopRibbon />}
        <Component {...type.content} {...passedProps} content={component.content} />
      </div>
    )
  } catch (e) {
    return null
  }
}
